module.exports = __webpack_public_path__ + "assets/images/feedback_1871cccfe9619b2d0647c947878b30c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-seven/feedback.png
// module id = 233
// module chunks = 0